import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { Z3KTabId } from 'z3k-settings/utils/tab-ids';
import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
import { selectDevice, selectSelectedDevice } from 'entities/device/lib';
import { set_service_mode } from 'console/climatic/settings-actions';
import { isClimatic, isLegacyDevice } from 'shared/contexts/device/config/utils';
import { partial } from 'lodash';
import { requestDeviceUpdate, } from 'console/redux/devices/items/actions';
import { getAPIErrorMessage } from 'api';
import { minimalZ3KConfig } from 'z3k-parser/lib';
export const open_z3k_settings = (device_id, activeTab = isMediumUI() ? Z3KTabId.settings : null, openedIds = []) => async (dispatch, getState) => {
    const state = getState();
    const config = selectDevice(state, device_id)?.z3k_config ?? minimalZ3KConfig;
    if (!config)
        return;
    const action = {
        type: 'OPEN_Z3K_SETTINGS',
        device_id,
        config,
        activeTab,
        openedIds,
    };
    dispatch(action);
};
export const close_z3k_settings = (device_id) => ({
    type: 'CLOSE_Z3K_SETTINGS',
    device_id: device_id,
});
export const clear_z3k_settings_error = (device_id) => ({ type: 'CLEAR_Z3K_SETTINGS_ERROR', device_id });
export const clear_z3k_settings = (device_id) => ({
    type: 'CLEAR_Z3K_SETTINGS',
    device_id,
});
export const save_z3k_settings_ok_action = (device_id, config) => ({
    type: 'SAVE_Z3K_SETTINGS__OK',
    device_id,
    config,
});
export const config_end_write = (device_id) => ({
    type: 'CONFIG_END_WRITE',
    device_id,
    status: false,
});
export var Z3KSettingsUpdateReason;
(function (Z3KSettingsUpdateReason) {
    Z3KSettingsUpdateReason["Z3KDialogSave"] = "Z3KDialogSave";
    Z3KSettingsUpdateReason["Z3KDialogApply"] = "Z3KDialogApply";
    Z3KSettingsUpdateReason["ClimaticDialogSave"] = "ClimaticDialogSave";
    Z3KSettingsUpdateReason["ClimaticDialogApply"] = "ClimaticDialogApply";
    Z3KSettingsUpdateReason["ConnectPlusWizard"] = "ConnectPlusWizard";
    Z3KSettingsUpdateReason["ZontWizard"] = "ZontWizard";
    Z3KSettingsUpdateReason["SaveTrustPhones"] = "SaveTrustPhones";
})(Z3KSettingsUpdateReason || (Z3KSettingsUpdateReason = {}));
export const saveZ3KSettingsOK = (device_id, config) => ({
    type: 'SAVE_Z3K_SETTINGS__OK',
    device_id,
    config,
});
export const save_z3k_settings = (config, commands, device_id, device_settings, reason) => async function (dispatch, getState, { api }) {
    dispatch({ type: 'SAVE_Z3K_SETTINGS__REQUEST', device_id });
    try {
        await api.save_z3k_config(device_id, config, commands, reason);
        if (device_settings && Object.keys(device_settings).length > 0) {
            await api.update_device(device_id, device_settings);
        }
        dispatch({ type: 'SAVE_Z3K_SETTINGS__OK', device_id, config });
    }
    catch ({ json }) {
        console.error(json);
        dispatch({ type: 'SAVE_Z3K_SETTINGS__FAIL', error: json, device_id });
    }
};
export function send_z3k_command(device_id, object_id, command_name, command_args, request_time = null, is_guaranteed = false) {
    return async (dispatch, getState, { api }) => {
        const command = {
            object_id,
            command_name,
            command_args,
        };
        try {
            dispatch({
                type: 'Z3K_COMMAND_SENT_TO_SERVER',
                command_name,
                device_id,
                object_id: object_id,
            });
            await api.send_z3k_command(device_id, command, is_guaranteed, request_time);
            dispatch({
                type: 'Z3K_COMMAND_SENT_TO_SERVER__OK',
                command_name,
                device_id,
                object_id: object_id,
            });
        }
        catch (error) {
            const error_message = getAPIErrorMessage(error, 'Произошла ошибка');
            if (command.object_id) {
                dispatch({
                    type: 'Z3K_COMMAND_SENT_TO_SERVER__FAIL',
                    device_id,
                    object_id: command.object_id,
                    error_message,
                });
                setTimeout(() => dispatch({
                    type: 'Z3K_COMMAND_TO_SERVER_RESET__FAIL',
                    device_id,
                    object_id: command.object_id,
                }), 0);
            }
            if (error.json.error === 'staff_access_denied') {
                if (command_name === 'RestartDevice') {
                    dispatch({
                        type: 'CLOSE_Z3K_RESTART_DIALOG',
                        device_id,
                    });
                }
                dispatch(openErrorDialog({
                    error_ui: getAPIErrorMessage(error, 'Необходимо получить разрешение от хозяина аккаунта.'),
                    error,
                }));
            }
        }
    };
}
export const close_z3k_restart_dialog = (device_id) => ({
    type: 'CLOSE_Z3K_RESTART_DIALOG',
    device_id,
});
export const upload_z3k_config_from_file = (device_id, config_file // Bibazavr - я не нашёл примеров этого типа
) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'UPLOAD_Z3K_CONFIG__REQUEST', device_id });
    const data = new FormData();
    data.append('device_id', device_id.toString());
    // Эта переменная генерируется webpack'ом
    // eslint-disable-next-line no-undef,@typescript-eslint/ban-ts-comment
    // @ts-ignore
    data.append('author', Z3K_CONFIG_AUTHOR);
    data.append('config_file', config_file);
    try {
        const config = await api.upload_z3k_config_from_file(data);
        dispatch({ type: 'UPLOAD_Z3K_CONFIG__OK', device_id, config });
        dispatch(openErrorDialog({
            error_ui: 'Конфигурация отправлена в прибор. Устройство будет перезагружено для применения изменений',
        }));
    }
    catch ({ json }) {
        console.error(json);
        dispatch({ type: 'UPLOAD_Z3K_CONFIG__FAIL', error: json, device_id });
    }
};
export const request_z3k_config_file_from_server = (device_id) => (dispatch, getState, { api }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.location = api.get_url('download_z3k_config_from_server', {
        device_id,
    }, true);
};
export const z3kSetServiceView = (device_id, isServiceView) => ({
    type: 'Z3K_SET_SERVICE_VIEW',
    isServiceView: isServiceView,
    device_id,
});
export const z3kSettingsSelectTab = (device_id, tabId) => ({
    type: 'Z3K_SETTINGS_SELECT_TAB',
    activeTab: tabId,
    device_id,
});
export const set_service_mode_view = () => (dispatch, getState, { api }) => {
    const selected_device = selectSelectedDevice(getState());
    const is_climatic = isClimatic(selected_device?.device_type);
    const is_legacy_device = isLegacyDevice(selected_device?.device_type);
    const toggleClimaticServiceMode = partial(set_service_mode, false);
    const toggleZ3KServiceMode = () => z3kSetServiceView(selected_device?.id ?? -1, false);
    const toogleLegacyServiceMode = () => requestDeviceUpdate(selected_device?.id ?? -1, {
        is_legacy_service_mode_view: false,
    });
    if (is_climatic) {
        return dispatch(toggleClimaticServiceMode());
    }
    if (is_legacy_device) {
        return dispatch(toogleLegacyServiceMode());
    }
    return dispatch(toggleZ3KServiceMode());
};
export const z3kSettingsUpdateOpenedIds = (device_id, openedIds) => ({ type: 'Z3K_SETTINGS_UPDATE_OPENED_IDS', openedIds, device_id });
